<h3 class="text-xl font-bold mb-6">
  {{ 'project.steps.proposalParameters.projectScope' | transloco }}
</h3>

<form [formGroup]="theForm">
  <div class="grid grid-cols-3 gap-4 p-5">
    <app-form-field-multiselect
      id="languages"
      fieldName="languages"
      [placeholder]="'multiselect.noSelect.language' | transloco"
      label="multiselect.select.language"
      [selectTranslatedOptions]="languageOptions()"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-multiselect>

    <app-form-field-multiselect
      id="countries"
      fieldName="countries"
      [placeholder]="'multiselect.noSelect.country' | transloco"
      label="multiselect.select.country"
      type="multiSelect"
      [selectTranslatedOptions]="countryOptions()"
      [isReadOnly]="true"
    ></app-form-field-multiselect>

    <app-form-field-multiselect
      id="functions"
      fieldName="functions"
      [placeholder]="'multiselect.noSelect.function' | transloco"
      label="multiselect.select.function"
      type="multiSelect"
      [selectTranslatedOptions]="functionOptions()"
      [isReadOnly]="true"
    ></app-form-field-multiselect>

    <app-multi-selection-label
      noSelectKey="multiselect.noSelect.language"
      [options]="this.languageOptions()"
      [selectedIds]="this.inputObject().languages ?? []"
    ></app-multi-selection-label>

    <app-multi-selection-label
      noSelectKey="multiselect.noSelect.country"
      [options]="this.countryOptions()"
      [selectedIds]="this.inputObject().countries ?? []"
    ></app-multi-selection-label>

    <app-multi-selection-label
      noSelectKey="multiselect.noSelect.function"
      [options]="this.functionOptions()"
      [selectedIds]="this.inputObject().functions ?? []"
    ></app-multi-selection-label>
  </div>

  @if (theForm.valid && hasChanges()) {
    <div class="flex justify-end gap-2 mt-4">
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="onSubmit()"
      ></app-project-step-save-button>
    </div>
  }
</form>
